import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./EventList.module.css";
import EventCategory from "componentsCustom/eventCategory/eventCategory";

const Events = (props) => {
  const { museum, updateEventSelected, events } = props;

  const [categories, setCategories] = useState([]);

  const [noTickets, setNoTickets] = useState(true);

  useEffect(() => {
    if (events && events[0] && events.length > 0) {
      var listableEvents = [];
      var tmpCat = [];
      events.forEach((event) => {
        if (event.eventi_child.length > 0) {
          listableEvents.push(event);
          if (!tmpCat.includes(event.categoria_evento?.nome_categoria)) {
            tmpCat.push(event.categoria_evento?.nome_categoria);
          }
        }
      });

      var tmpList = [];

      tmpCat.forEach((category) => {
        tmpList.push({
          name: category,
          events: listableEvents.filter(
            (e) => e.categoria_evento?.nome_categoria === category
          ),
        });
      });

      setCategories(tmpList);

      setNoTickets(
        !listableEvents.filter((e) => e.biglietti_eventis.length > 0).length > 0
      );
    }
  }, [events]);

  const { t } = useTranslation();

  const windowSize = props.windowSize;

  const componentsContent = categories.map((category, key) => {
    return (
      <EventCategory
        category={category}
        key={key}
        museum={museum}
        updateEventSelected={updateEventSelected}
        windowSize={windowSize}
      />
    );
  });

  return (
    <div
      className={styles.ticketListContainer}
      style={{
        color: museum?.customizations?.eventDetailsTextColor
          ? museum?.customizations?.eventDetailsTextColor
          : "#000000",
        borderRadius: windowSize.innerWidth > 800 ? "0" : "20px",
        marginBottom: windowSize.innerWidth > 800 ? "0" : "50px",
      }}
    >
      <div
        style={{
          // display: "inline-block",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {categories && categories.length > 0 && !noTickets && (
          <>
            <h4
              style={{
                marginTop: windowSize.innerWidth > 800 ? "10px" : 0,
                marginBottom: windowSize.innerWidth > 800 ? "10px" : 0,
              }}
            >
              {t("buyEventsTickets")}
            </h4>
            {componentsContent}
          </>
        )}
        {noTickets && (
          <div>
            <h4>{t("noEventMessage")}</h4>
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
